import React from 'react';
import { categoryNavBarDataFetcher } from '../../src/datafetchers/CategoryPage';
import { storeDataFetcher } from '../../src/datafetchers/Store';
import { getFilteredCategoryContent } from '../../src/Utils/helper';
import ColoringPagesMain from '../../src/components/ColorPage/ColoringPagesMain';

export async function getServerSideProps(context) {
  const categoryNavBarApiData = await categoryNavBarDataFetcher();
  const data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  let seoFootnoteData;
  const storeItems = data?.data?.cards?.items;
  for (let i = 0; i < storeItems.length; i++) {
    if (storeItems[i]?.itemType == 'SEO_FOOTNOTE') {
      seoFootnoteData = storeItems[i];
      break;
    }
  }
  return {
    props: {
      categoryNavBarData: getFilteredCategoryContent(
        categoryNavBarApiData?.data,
      ),
      seoFootnoteData: seoFootnoteData,
    },
  };
}

const ColorPageIndex = (props) => {
  const { categoryNavBarData, seoFootnoteData } = props;
  return (
    <ColoringPagesMain
      categoryNavBarData={categoryNavBarData}
      seoFootnoteData={seoFootnoteData}
    />
  );
};

export default ColorPageIndex;
